import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Input,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Spinner,
  Alert,
  Divider,
} from '@chakra-ui/react';
import axios from 'axios';
import { API_URL } from "../../constants";
import { getAuthToken } from "../../helpers/helpers";
import { getCountry } from "../../config/countryConfig";

export default function PointsConfig() {
  const isAlgeria = getCountry() === 'DZ';

  const [points, setPoints] = useState({
    normalSalePoints: '',
    nearExpiryPoints: '',
    extraSalePoints: '',
    dermoNormalSalePoints: '',
    dermoNearExpiryPoints: '',
    dermoExtraSalePoints: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchPointsConfig();
  }, []);

  const fetchPointsConfig = async () => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${API_URL}/api/points-config`, {
        headers: {
          'x-access-token': token,
          'Authorization': `Bearer ${token}`
        }
      });
      const data = response.data;
      setPoints({
        normalSalePoints: data.normalSalePoints ?? 3,
        nearExpiryPoints: data.nearExpiryPoints ?? 10,
        extraSalePoints: data.extraSalePoints ?? 5,
        dermoNormalSalePoints: data.dermoNormalSalePoints ?? 3,
        dermoNearExpiryPoints: data.dermoNearExpiryPoints ?? 10,
        dermoExtraSalePoints: data.dermoExtraSalePoints ?? 5
      });
    } catch (error) {
      setErrorMessage("Erreur lors du chargement de la configuration des points");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const token = getAuthToken();
      await axios.put(`${API_URL}/api/points-config`, {
        normalSalePoints: Number(points.normalSalePoints),
        nearExpiryPoints: Number(points.nearExpiryPoints),
        extraSalePoints: Number(points.extraSalePoints),
        dermoNormalSalePoints: Number(points.dermoNormalSalePoints),
        dermoNearExpiryPoints: Number(points.dermoNearExpiryPoints),
        dermoExtraSalePoints: Number(points.dermoExtraSalePoints)
      }, {
        headers: {
          'x-access-token': token,
          'Authorization': `Bearer ${token}`
        }
      });
      setSuccessMessage("Configuration mise à jour avec succès");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      setErrorMessage("Erreur lors de la mise à jour de la configuration");
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    setPoints({
      ...points,
      [e.target.name]: e.target.value
    });
  };

  if (loading) return <Box mt="64px" textAlign="center"><Spinner size="xl" /></Box>;

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Box px={4} w="100%" maxW="800px" mx="auto">
      <Text fontSize="2xl" fontWeight="bold" mb={6}>Configuration des Points</Text>
      <Box p={6} borderWidth={1} borderRadius="xl" boxShadow="lg" bg="white">
        <form onSubmit={handleSubmit}>
          <VStack spacing={4} align="stretch">
            {successMessage && (
              <Alert status="success" bg="green.500" color="white" borderRadius="md">
                {successMessage}
              </Alert>
            )}
            {errorMessage && (
              <Alert status="error" bg="red.500" color="white" borderRadius="md">
                {errorMessage}
              </Alert>
            )}
            <FormControl>
              <FormLabel>Points de vente standards</FormLabel>
              <Input
                type="number"
                name="normalSalePoints"
                value={points.normalSalePoints}
                onChange={handleChange}
                min="1"
                step="1"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Points de vente produits proches de la péremption</FormLabel>
              <Input
                type="number"
                name="nearExpiryPoints"
                value={points.nearExpiryPoints}
                onChange={handleChange}
                min="1"
                step="1"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Points de vente extra</FormLabel>
              <Input
                type="number"
                name="extraSalePoints"
                value={points.extraSalePoints}
                onChange={handleChange}
                min="1"
                step="1"
              />
            </FormControl>
            
            {!isAlgeria && (
              <>
                <Text fontSize="xl" fontWeight="bold" mt={4} mb={2}>Produits Dermo</Text>
                <Divider />
                <FormControl>
                  <FormLabel>Points de vente standards (Dermo)</FormLabel>
                  <Input
                    type="number"
                    name="dermoNormalSalePoints"
                    value={points.dermoNormalSalePoints}
                    onChange={handleChange}
                    min="1"
                    step="1"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Points de vente produits proches de la péremption (Dermo)</FormLabel>
                  <Input
                    type="number"
                    name="dermoNearExpiryPoints"
                    value={points.dermoNearExpiryPoints}
                    onChange={handleChange}
                    min="1"
                    step="1"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Points de vente extra (Dermo)</FormLabel>
                  <Input
                    type="number"
                    name="dermoExtraSalePoints"
                    value={points.dermoExtraSalePoints}
                    onChange={handleChange}
                    min="1"
                    step="1"
                  />
                </FormControl>
              </>
            )}

            <Button
              colorScheme="brand"
              bg="#0D6B62"
              color="white"
              _hover={{ bg: "#0B5D55" }}
              isLoading={saving}
              type="submit"
              mt={4}
            >
              Enregistrer
            </Button>
          </VStack>
        </form>
      </Box>
      </Box>
    </Box>
  );
}
